import {Injectable,Pipe,PipeTransform} from '@angular/core';
import {StatutOubli} from "@domain/user/user-dto";
import {AppComponent} from "../../app.component";
import {ParticipantExterne} from "@domain/participant/participant-externe";

/**
 * Pipe de formatage des informations d'un utilisateur externe<br /><br />
 *
 * value : Utilisateur externe à afficher<br />
 */
@Injectable({providedIn: 'root'})
@Pipe({
    name: 'userExterne'
})
export class UserExternePipe implements PipeTransform {

    /**
     * Formatage de l'utilisateur externe passé en paramètre
     *
     * @param value Utilisateur externe à afficher
     */
    transform(value: ParticipantExterne): string {
        return UserExternePipeTransform(value);
    }
}

/**
 * Fonction de formatage d'un utilisateur externe (aka participant externe) sous la forme : "nom prénom".<br>
 * La fonction est conservée par cohérence avec {@link UserPipeTransform}.
 *
 * @param value L'utilisateur externe à formater
 */
export function UserExternePipeTransform(value: ParticipantExterne) {
    //Si une des valeurs permettant de formatter l'utilisateur est renseignée, on affiche la valeur formatée
    if (value?.statutOubli === StatutOubli.OUBLIE || value?.nom || value?.prenom) {
        //Gestion des utilisateurs anonymisés (RGPD)
        const isOublie = value.statutOubli === StatutOubli.OUBLIE || (!value.nom && !value.prenom);
        const nom: string = isOublie ? AppComponent.translate('admin.entreprise.utilisateurs.externes.nomAnonyme') : value.nom?.toUpperCase() ?? '';
        const prenom: string = isOublie ? AppComponent.translate('admin.entreprise.utilisateurs.externes.prenomAnonyme') : value.prenom ?? '';

        //Retour de la chaîne formatée
        return (`${nom} ${prenom}`).trim();
    } else {
        //Sinon, on renvoie "Non défini"
        return this.translateService.instant('admin.entreprise.utilisateurs.externes.nonDefini')
    }
}